module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('data-table-component', _vm._b({}, 'data-table-component', _vm.$data, false))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-078cd2e2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PriceHistory/DataTable.vue
// module id = 1227
// module chunks = 2